var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "7.001 11 15.999 9"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "m8.647 11.284 6.354 6.379 6.353-6.38a.963.963 0 0 1 1.364 0 .97.97 0 0 1 0 1.37l-7.036 7.063a.96.96 0 0 1-1.363 0l-7.036-7.063a.97.97 0 0 1 0-1.37.963.963 0 0 1 1.364 0"
})));
export default SvgChevronDown;